import React from 'react';
import BottomBreadcrumb from './BottomBreadcrumb/BottomBreadcrumb';
import MiniBottomBar from './BottomBreadcrumb/MiniBottomBar';
import * as Constants from '../../utilities/constants/Constants';
import CopyrightInfo from './CopyrightInfo/CopyrightInfo';
import MediaQuery from 'react-responsive';

const Footer = props => {
  const {
    sidebarIsHiddenInDesktop,
    page,
    showSideBar,
    handleSideBar,
    isFranceAccount
  } = props;
  function classforBottomBar() {
    if (
      (page === Constants.DESIGN_PAGE ||
        page === Constants.FILE_PROCESSING_PAGE ||
        page === Constants.DESIGN_SHARE_PAGE) &&
      !sidebarIsHiddenInDesktop
    ) {
      return 'bottom-bar-design-page';
    }
    return 'home';
  }

  return (
    <>
      <MediaQuery query='(max-width: 767px)'>
        {page === Constants.DESIGN_PAGE ? (
          <MiniBottomBar
            handleSideBar={handleSideBar}
            showSideBar={showSideBar}
            sidebarIsHiddenInDesktop={sidebarIsHiddenInDesktop}
          />
        ) : null}
      </MediaQuery>
      <MediaQuery query='(min-width: 767px)'>
        <BottomBreadcrumb customClass={classforBottomBar()} />
      </MediaQuery>
      <CopyrightInfo isFranceAccount={isFranceAccount} />
    </>
  );
};

export default Footer;
